import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import * as _ from "lodash";
import {
  faChevronUp,
  faChevronDown,
  faChevronRight,
} from "@fortawesome/pro-solid-svg-icons";
import { faSearch } from "@fortawesome/pro-light-svg-icons";
import { SelectionModel } from "@angular/cdk/collections";
import { MatTableDataSource } from "@angular/material/table";
import { DatapointService } from "@services/datapoint.service";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, MatSortable } from "@angular/material/sort";
import { debounceTime } from "rxjs/operators";

@Component({
    selector: "app-search",
    templateUrl: "./search.component.html",
    styleUrls: ["./search.component.scss"],
    standalone: false
})
export class SearchDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    public datapointService: DatapointService,
    public dialogRef: MatDialogRef<SearchDialogComponent>
  ) {
    if (data) {
      this.dataSetListing = data.dataSetListing;
      this.existingDataFields = data.existingDataFields;
    }
  }
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort!: MatSort;
  datasets: any = [];

  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;
  faChevronRight = faChevronRight;
  faSearch = faSearch;

  public fieldForm!: UntypedFormGroup;
  public error: string = "Check collections to view available fields";
  public page: number = 1;
  public count: number = 20000;
  public dataFields: any[] = [];
  public canvasFields: any[] = [];
  public fieldItem: any;
  showData = false;
  displayedColumns: string[] = ["select", "type", "name", "dataset"];
  dataSetListing: any;
  existingDataFields: any;
  dataSource: any;
  selection: any;
  filterValues: any = {};
  loading = false;
  timer: any;
  firstTime = true;

  getDataSetGroups() {
    if (this.dataSetListing && this.dataSetListing.length > 300) {
      this.dataSetListing.isAllSelected = true;
      this.dataSetListing.isAllCollapsed = true;
      this.datasets = this.dataSetListing;
      this.getDataPoints();
    } else {
      this.datapointService.getDataSetGroups().subscribe((data: any) => {
        data.data.forEach((group: any) => {
          const datasetArray = group.dataSets.data;
          const myOrderedArray = _.sortBy(datasetArray, (o) => o.name);
          group.dataSets.data = myOrderedArray;
        });

        data.data.isAllSelected = true;
        data.data.isAllCollapsed = true;
        this.datasets = data.data;
        this.selectUnselectAll(this.datasets);
        // this.getDataPoints();
      });
    }
  }

  getDataPoints() {
    this.loading = true;
    let datasetlist = this.datasets;
    let dataSetArray: any[] = [];
    this.firstTime = false;
    this.fieldForm.disable();

    //dataSetArray is a comma separated list of dataset IDs from the selected datasets
    datasetlist.forEach((group: any) => {
      group.dataSets.data.forEach((item: any) => {
        if (item.isSelected) {
          dataSetArray.push(item.id);
        }
      });
    });

    if (dataSetArray.length <= 0) {
      this.error = "Check collections to view available fields";
      //setTimeout(() => (this.error = ""), 3000);
      this.dataSource = [];
      this.showData = false;
      this.loading = false;
    } else {
      this.page = 1;
      this.datapointService
        .getDataPoints(dataSetArray)
        .subscribe((data: any) => {
          if (data.data.length <= 0) {
            this.showData = false;
            this.error = "No results found";
            this.dataFields = [];
            this.dataSource = [];
            setTimeout(() => (this.error = ""), 3000);
            return;
          } else {
            this.showData = true;
            this.dataFields = data.data;
            this.error = "";
            const that = this;

            this.dataFields = this.dataFields.filter(function (element: any) {
              if (
                that.existingDataFields.filter(function (e: any) {
                  return e.id === element.id;
                }).length > 0
              ) {
                /* vendors contains the element we're looking for */
              } else {
                return element;
              }
            });

            this.dataSource = new MatTableDataSource(<any>this.dataFields);
            this.selection = new SelectionModel<any>(true, []);
            this.dataSource.paginator = this.paginator;
            //this.sort.sort({ id: "name", start: "asc" } as MatSortable);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator.firstPage();
            this.applyFilter(this.fieldForm.get("field")!.value);
            this.loading = false;
            this.fieldForm.enable();
            this.dataSource.sortingDataAccessor = (
              item: any,
              property: any
            ) => {
              switch (property) {
                case "dataset":
                  return item.dataSet.data.name;
                case "name":
                  return item.name;
                default:
                  return item[property];
              }
            };
          }
        });
    }
  }

  //Click event on parent checkbox
  parentCheck(parentObj: any) {
    for (var i = 0; i < parentObj.dataSets.data.length; i++) {
      parentObj.dataSets.data[i].isSelected = parentObj.isSelected;
    }
    this.expandCollapse(parentObj);
    this.clearTimeout();
  }

  //Click event on child checkbox
  childCheck(parentObj: any, childObj: any) {
    parentObj.isSelected = childObj.every(function (itemChild: any) {
      return itemChild.isSelected == true;
    });

    this.clearTimeout();
  }
  clearTimeout() {
    const that = this;
    clearTimeout(this.timer);
    this.timer = setTimeout(function () {
      that.getDataPoints();
    }, 2000);
  }

  //Expand/Collapse event on each parent
  expandCollapse(obj: any) {
    obj.isClosed = !obj.isClosed;
  }

  //Click event on master select
  selectUnselectAll(obj: any) {
    obj.isAllSelected = !obj.isAllSelected;
    for (var i = 0; i < obj.length; i++) {
      obj[i].isSelected = obj.isAllSelected;
      for (var j = 0; j < obj[i].dataSets.data.length; j++) {
        obj[i].dataSets.data[j].isSelected = obj.isAllSelected;
      }
    }

    this.getDataPoints();
  }
  //Master expand/ collapse event
  expandCollapseAll(obj: any) {
    for (var i = 0; i < obj.length; i++) {
      obj[i].isClosed = !obj.isAllCollapsed;
    }
    obj.isAllCollapsed = !obj.isAllCollapsed;
  }

  itemsSelected() {
    let selected = 0;
    if (this.selection && this.selection._selection) {
      var selectArray = [...this.selection._selection];
      selected = selectArray.length;
    }
    return selected;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  apply(): void {
    const retVal = {
      selection: this.selection._selection,
      datasets: this.datasets,
    };
    this.dialogRef.close(retVal);
  }

  applyFilter(filter: any) {
    let filterValue = "";
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return data["name"].trim().toLowerCase().indexOf(filter) != -1;
    };

    if (filter) {
      if (typeof filter != "string") {
        filterValue = (filter.target as HTMLInputElement).value;
      } else {
        filterValue = filter;
      }
    }
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.filter == "") {
      this.dataSource.filterPredicate = () => {
        return true;
      };
      this.dataSource.filter = true;
    }
  }

  initForm() {
    this.fieldForm = this.fb.group({
      label: new UntypedFormControl(),
      field: new UntypedFormControl(),
      collection: new UntypedFormControl(),
    });
    this.getDataSetGroups();
  }
  ngOnInit(): void {
    this.initForm();
  }
}
